import { collection, getDocs, query, where } from "firebase/firestore";
import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import BlogCard from "../../components/blogcard/BlogCard";
import Spinner from "../../components/spinner/Spinner";
import { db } from "../../firebase";
import "./categoryblog.css";

const CategoryBlog = ({ setActive }) => {
  const [categoryBlogs, setCategoryBlogs] = useState([]);
  const [loading, setLoading] = useState(false);
  const { category } = useParams();

  const getCategoryBlogs = async () => {
    setLoading(true);
    const blogRef = collection(db, "blogs");
    const categoryBlogQuery = query(blogRef, where("category", "==", category));
    const docSnapshot = await getDocs(categoryBlogQuery);
    let categoryBlogs = [];
    docSnapshot.forEach((doc) => {
      categoryBlogs.push({ id: doc.id, ...doc.data() });
    });
    setCategoryBlogs(categoryBlogs);
    setLoading(false);
  };

  useEffect(() => {
    document.title = `${category} Blogs - youvaraj.com`;
    getCategoryBlogs();
    setActive(null);
  }, [category]);

  if (loading) {
    return <Spinner />;
  }

  return (
    <div className="category-page">
      <div className="container">
        <div className="page-title-header">
          <h1 className="page-title">{category}</h1>
          <p className="page-subtitle">
            Explore blogs in the {category} category
          </p>
        </div>
        <div className="row">
          {categoryBlogs?.map((item) => (
            <div className="col-md-6" key={item.id}>
              <BlogCard {...item} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CategoryBlog;
